import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddStudent from "./pages/AddStudent";
import Students from "./pages/Students";
import DashboardLayout from "./layouts/DashboardLayout";
import StudentDetails from "./pages/StudentDetails";
import InvoicePage from "./pages/InvoicePage";
import GstInvoicesPage from "./pages/GstInvoicesPage";
import InvoicePreview from "./pages/InvoicePreview";
import BatchesPage from "./pages/BatchesPage";
import AttendancePage from "./components/AttendancePage";
import ContactMessagesTable from "./pages/ContactMessages";
import Managers from "./pages/Managers";
import Teachers from "./pages/Teachers";
import Courses from "./pages/Courses";
import CouponsPage from "./pages/CouponsPage";
import DemoRequestsPage from "./pages/DemoRequestsPage";
import CourseView from "./pages/CourseView";
import CoursesJSON from "./pages/CoursesJSON";
import IndividualJSON from "./pages/IndividualJSON";
import IndividualView from "./pages/IndividualView";
import Services from "./pages/Services";
import ServiceView from "./pages/ServiceView";
import BlogAdmin from "./pages/BlogAdmin";
import BlogView from "./pages/BlogView";


const Page = ({ title }) => (
  <div className="p-6 text-white text-2xl">{title}</div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Login Page */}
        <Route path="/" element={<Login />} />

        <Route path="/dashboard" element={<DashboardLayout />}>

          <Route index element={<div>Dashboard Home</div>} />
          <Route path="students" element={<Students />} />
          <Route path="add-student" element={<AddStudent />} />
          <Route path="/dashboard/student-details" element={<StudentDetails />} />
          <Route path="/dashboard/invoice" element={<InvoicePage />} />
          <Route path="/dashboard/GstInvoicesPage" element={<GstInvoicesPage />} />
          <Route path="/dashboard/InvoicePreview" element={<InvoicePreview />} />
          <Route path="/dashboard/batches" element={<BatchesPage />} />
          <Route path="/dashboard/attendance" element={<AttendancePage />} />
          <Route path="/dashboard/ContactMessages" element={<ContactMessagesTable />} />
          <Route path="/dashboard/managers" element={<Managers />} />
          <Route path="/dashboard/teachers" element={<Teachers />} />
          <Route path="/dashboard/courses" element={<Courses />} />
          <Route path="/dashboard/CoursesJSON" element={<CoursesJSON />} />
          <Route path="/dashboard/IndividualJSON" element={<IndividualJSON />} />
          <Route path="/dashboard/individual-view" element={<IndividualView />} />
          <Route path="/dashboard/course-view" element={<CourseView />} />
          <Route path="/dashboard/services" element={<Services />} />
          <Route path="/dashboard/service-view" element={<ServiceView />} />
          <Route path="/dashboard/coupons" element={<CouponsPage />} />
          <Route path="/dashboard/demorequests" element={<DemoRequestsPage />} />
          <Route path="/dashboard/blogs" element={<BlogAdmin />} />
          <Route path="/dashboard/blog-view" element={<BlogView />} />

        </Route>

        {/* Dashboard Page */}
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        {/* <Route path="/dashboard/students" element={<Students />} /> */}
        {/* <Route index element={<Page title="Dashboard" />} />
        <Route path="managers" element={<Page title="Managers" />} />
        <Route path="teachers" element={<Page title="Teachers" />} />
        <Route path="students" element={<Page title="Students" />} />
        <Route path="batches" element={<Page title="Batches" />} />
        <Route path="attendance" element={<Page title="Attendance" />} />
        <Route path="courses" element={<Page title="Courses" />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
